import React from "react";
import { createPortal } from "react-dom";

const CollapsedNavigationFlyout = ({
  id,
  open,
  direction,
  position,
  panelRef,
  label,
  children
}) =>
  createPortal(
    <aside
      id={id}
      ref={panelRef}
      className={`sidebar-submenu-flyout${open ? " is-open" : ""}`}
      aria-hidden={!open}
      aria-label={label}
      role="navigation"
      dir={direction}
      style={position}
    >
      <ul>{children}</ul>
    </aside>,
    document.body
  );

export default CollapsedNavigationFlyout;
